/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Data related to a company.   (bipro-allgemein::Unternehmen)
 */
export interface Company {
  /**
   * Unique BaFin number for the company, e.g. \"5055\" for Verti.
   */
  companyNumber?: string;
}
